import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgHelp = (props, ref) => /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 282 360", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: [
  /* @__PURE__ */ jsxs("defs", { children: [
    /* @__PURE__ */ jsxs("linearGradient", { x1: "23.878%", y1: "34.681%", x2: "81.69%", y2: "73.104%", id: "Help_svg__a", children: [
      /* @__PURE__ */ jsx("stop", { stopColor: "#D6D7D8", offset: "0%" }),
      /* @__PURE__ */ jsx("stop", { stopColor: "#EEE", offset: "100%" })
    ] }),
    /* @__PURE__ */ jsxs("linearGradient", { x1: "42.625%", y1: "40.899%", x2: "58.984%", y2: "88.021%", id: "Help_svg__b", children: [
      /* @__PURE__ */ jsx("stop", { stopColor: "#D6D7D8", offset: "0%" }),
      /* @__PURE__ */ jsx("stop", { stopColor: "#EEE", offset: "100%" })
    ] })
  ] }),
  /* @__PURE__ */ jsxs("g", { fillRule: "nonzero", fill: "none", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M162.584 107.926c3.533-6.106 12.754-7.875 18.275-3.503 1.77 1.402 3.23 3.332 5.364 4.058 5.325 1.81 10.389-4.86 15.952-4.053 9.514 1.379 6.968 20.304 16.48 21.703 5.305.78 9.843-5.236 15.149-4.47 7.592 1.095 8.674 14.297 16.308 15.04 2.824.274 5.456-1.416 8.263-1.82 2.809-.406 6.45 1.808 5.458 4.479-1.583 7.28-1.362 7.28-3.48 14.11-4.064 13.105-7.617 26.638-18.72 34.633-11.104 7.995-22.983 12.848-36.1 16.672-11.937 3.479-25.74 6.099-38.117 4.952-16.094-1.492-30.65-10.859-41.652-22.757-11.002-11.9-18.937-26.268-26.764-40.481 3.18 2.988 8.456.415 11.28-2.915 2.823-3.33 5.212-7.644 9.437-8.703 3.596-.901 7.497.922 11.045-.157 6.985-2.124 8.134-13.713 15.362-14.726 2.792-.392 5.67 1.076 8.396.357 4.937-1.302 5.497-7.983 8.064-12.42Z",
        fill: "#E94A47"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m166 203.492 2.689-1.302a379.487 379.487 0 0 1 .234-48.19c6.461 4.29 14.442 6.125 22.077 5.077a167.724 167.724 0 0 0-.454 45.923A141.036 141.036 0 0 0 166 203.492Z",
        fill: "#F2A19C"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M181.613 170.95c-4.603-.377-8.805-2.85-12.211-5.94-7.245-6.576-11.497-16.274-11.4-26.007.031-3.148.5-6.312 1.602-9.265 3.867-10.366 16.21-16.817 27.03-14.126 4.23 1.051 8.153 3.34 11.057 6.562 5.866 6.508 7.05 16.027 5.93 24.68-.771 5.942-2.572 11.91-6.313 16.617-3.741 4.708-9.667 7.973-15.695 7.48Z",
        fill: "#FFBEB6"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M199 148.918c-3.342 4.74-9.55 5.622-15.338 5.428-5.505-.183-9.312-2.516-13.662-6.346 2.21 4.533 2.033 5.49 5.145 9.037 3.294 3.754 6.508 5.768 12.435 4.66 1.157-.216 4.014-1.97 4.923-2.72 4.003-3.294 4.355-5.33 6.497-10.059Z",
        fill: "#FFF"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M197.63 176c.12 0 .24-.054.328-.16 1.358-1.628.143-3.816-.834-5.573l-.274-.496c-1.466-2.7-1.477-6.332-.028-9.041.167-.314.355-.626.543-.94.742-1.241 1.51-2.523 1.3-4.056-.175-1.28-.989-2.288-1.775-3.261-.891-1.105-1.662-2.06-1.31-3.147.201-.624.901-1.087 1.577-1.532.945-.624 2.018-1.331 1.819-2.67-.262-1.785-1.67-2.759-3.03-3.7-.558-.385-1.085-.75-1.53-1.165-.99-.92 0-3.171.328-3.839.2-.41.427-.809.654-1.208.54-.953 1.099-1.939 1.335-3.09.48-2.334-.528-5.01-2.567-6.82-1.725-1.529-4.303-2.496-6.585-3.28-.236-.081-.488.066-.56.328-.074.263.058.541.296.623 2.203.759 4.687 1.685 6.29 3.108 1.344 1.193 2.742 3.432 2.252 5.822-.202.984-.697 1.857-1.219 2.78-.235.415-.472.833-.682 1.261-.525 1.073-1.588 3.713-.114 5.08.494.458 1.072.86 1.632 1.247 1.245.861 2.421 1.674 2.619 3.015.094.637-.467 1.044-1.392 1.653-.776.513-1.656 1.092-1.965 2.053-.53 1.646.495 2.916 1.488 4.146.7.866 1.421 1.762 1.557 2.747.158 1.152-.482 2.223-1.16 3.355-.197.329-.393.655-.569.984-1.612 3.015-1.599 7.059.032 10.06l.278.506c1.04 1.87 1.769 3.38.94 4.374a.537.537 0 0 0 .026.704c.08.088.19.132.3.132Z",
        fill: "#E94A47"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M3.804 34.566c3.661.245 6.88 2.562 10.32 3.844 1.2.447 2.729.828 3.613-.103 1.049-1.102.191-2.893-.653-4.162C12.307 26.968 2.529 9.23 6.6 10.615c8.733 4.85 8.676 17.986 16.4 24.332 1.473-.139.507-1.835-.275-3.098l-8.403-13.544c-1.396-2.25-2.818-4.533-4.784-6.301-1.73-1.559-4.112-3.542-3.151-5.668 2.405-.688 4.732 1.208 6.414 3.068a57.688 57.688 0 0 1 8.086 11.486c1.666 3.116 3.061 6.407 5.193 9.221.99 1.305 2.158 2.58 3.252 3.882.172-.248.328-.508.44-.803.647-1.703-.108-3.587-.852-5.246C25.503 20.318 17.462 5.419 18.67 5.068c4.55-1.318 13.267 16.76 16.49 27.185.384 1.248.812 2.55 1.756 3.448 2.937 2.8 7.155-2.239 9.298-5.69 2.142-3.45 6.518-7.92 8.972-6.186-3.732 9.874-13.013 18.316-11.85 28.813.689 6.212 4.981 11.32 8.938 16.145 13.744 16.768 21.71 30.573 33.528 48.762 1.57 2.416 7.426 12.486 5.965 14.97-.916 1.558-3.11-.271-4.726.527-4.66 2.303-8.5 6.235-10.702 10.958-15.683-19.9-23.725-44.587-33.902-67.813-2.368-5.403-4.96-10.886-9.217-14.959-3.252-3.112-7.353-5.273-10.354-8.628-.394-.44-.763-.918-1.105-1.42-4.181-3.416-9.562-9.172-12.848-10.846-2.42-1.237-7.983-5.96-5.11-5.768Z",
        fill: "#FFBEB6"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M39 349.494a7306.879 7306.879 0 0 1 9.653-96.663c1.551-14.558 3.02-31.342 13.834-41.221 8.653-7.906 28.64-7.652 34.966-5.323 0 0 3.187 6.922 11.989 6.986 5.013.037 8.838-4.007 9.468-8.908 11.324-1.663 20.013-1.48 28.664 5.026 26.644-31.55 43.033-58.321 59.035-90.391 6.301 3.99 14.089 9.106 20.391 13.097-17.026 47.503-34.052 82.33-54.616 128.416-2.465 5.524-2.654 22.899-3.472 28.892-.65 4.76-.2 9.59.092 14.385a217.602 217.602 0 0 1-2.28 47.21c-2.449-3.262-12.595-5.137-16.659-4.738-4.062.4-7.914 1.946-11.898 2.827-13.352 2.952-27.092-1.67-40.748-2.37-19.53-.998-39.143 6.062-58.419 2.775Z",
        fill: "url(#Help_svg__a)",
        transform: "matrix(-1 0 0 1 287 -14)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#23286B",
        d: "m178.5 224 12.5-12.5-12.5-12.5-12.5 12.5zM178.5 321l12.5-12.179L178.5 228 166 308.821z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M101.908 140c3.607 0 7.016-3.53 8.146-4.829 2.633-3.022 5.595-6.43 9.23-5.89.948.141 1.836.549 2.776.983 1.033.476 2.1.967 3.275 1.087 4.077.428 7.076-3.706 8.496-6.204.192-.335.38-.677.573-1.02 1.545-2.776 3.144-5.65 5.884-6.744 2.728-1.087 5.76-.076 8.692.904.867.29 1.764.592 2.642.834 2.894.796 6.198.384 8.223-1.028 1.244-.867 1.987-2.086 2.152-3.525a.507.507 0 0 0-.433-.565.496.496 0 0 0-.548.445c-.133 1.153-.712 2.096-1.725 2.803-1.774 1.238-4.822 1.605-7.413.887-.852-.233-1.737-.53-2.592-.817-3.095-1.037-6.296-2.108-9.355-.885-3.067 1.225-4.753 4.256-6.384 7.185-.19.341-.378.68-.568 1.013-1.3 2.288-4.018 6.058-7.545 5.705-1.015-.106-1.964-.542-2.968-1.006-.961-.443-1.955-.9-3.039-1.061-4.153-.617-7.447 3.162-10.091 6.2-1.3 1.492-5.785 6.127-9.598 3.918a.487.487 0 0 0-.674.193.516.516 0 0 0 .188.693 5.183 5.183 0 0 0 2.656.724ZM207 129.877c-3.938-9.85-13.157-17.605-23.602-18.742-10.445-1.136-21.53 4.98-25.398 14.856 13.887 10.38 33.685 11.947 49 3.886Z",
        fill: "#E94A47"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M86.556 334.654c-1.403-.6-2.46-1.558-2.475-3.026.462-1.513 13.585-1.148 20.377-1.722 4.424-.373 8.955-.74 13.244.386 1.93.507 3.815 1.308 5.733 1.841.432-.087.85-.182 1.264-.277-5.79-1.829-13.424-4.782-12.958-7.366 2.132-2.137 9.601.308 12.448 1.383 5.123 1.935 9.322 2.742 13.318 3.856 4.193-.163 9.084-.053 12.988.927 20.781 5.216 42.678 1.22 63.736-2.794L245 322c-1.995 7.68-.88 14.138-2.876 21.819-13.993-.326-30.18 1.326-43.643 0-10.035-.988-20.154-4.72-29.955-2.393-6.21 1.476-12.094 4.252-18.425 5.082-10.201 1.34-20.936-2.45-30.694.758-8.153 2.68-15.161 8.255-23.536 6.342-3.164-.723 15.593-8.897 24.743-12.59-6.477-3.36-14.217-.55-21.545-.506-7.195.045-15.564 1.7-20.926-3.193-.92-1.632 2.674-2.299 8.413-2.665Z",
        fill: "#FFBEB6"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M44.27 332.337c18.447 3.516 29.655 3.993 48.115 6.98A73.743 73.743 0 0 0 96 359.287c-29.167.79-45.05.756-74.165.67-10.47-1.005-9.545-30.018-7.643-45.287 1.947-15.639 16.204-35.655 21.104-50.623 6.555-20.034 8.777-24.648 21.438-44.19 2.297-3.548 6.76-11.541 10.47-9.54-3.091 10.502-5.226 22.91-8.316 33.412-6.036 20.507-7.066 16.03-8.136 37.39-.5 9.965-3.146 30.277-6.48 40.172-.119.347-.36 10.979-.002 11.046Z",
        fill: "url(#Help_svg__b)",
        transform: "matrix(-1 0 0 1 287 -14)"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#FFF", d: "M220 245h-29v15h29z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M146.847 153.853h1.207v-18.316h-1.207c-4.886 0-8.847 4.1-8.847 9.158 0 5.057 3.96 9.158 8.847 9.158Z",
        fill: "#151A4F"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M163.125 171.253h9.623a.91.91 0 0 0 .897-.92.91.91 0 0 0-.897-.921h-9.623c-8.329 0-15.105-6.953-15.105-15.498v-3.72a.91.91 0 0 0-.897-.92.91.91 0 0 0-.897.92v3.72c0 9.56 7.581 17.339 16.9 17.339Z",
        fill: "#23286B"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M178.607 174h-4.44c-1.803 0-3.264-1.435-3.264-3.205s1.461-3.206 3.264-3.206h4.44c1.803 0 3.264 1.435 3.264 3.206 0 1.77-1.461 3.205-3.264 3.205Z",
        fill: "#151A4F"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M152.167 158.432c2.776 0 5.027-2.27 5.027-5.07v-18.25c0-2.8-2.251-5.07-5.027-5.07-2.776 0-5.027 2.27-5.027 5.07v18.25c0 2.8 2.25 5.07 5.027 5.07Z",
        fill: "#23286B"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M214.153 153.853h-1.207v-18.316h1.207c4.886 0 8.847 4.1 8.847 9.158 0 5.057-3.96 9.158-8.847 9.158Z",
        fill: "#151A4F"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M209.747 158.432c-2.776 0-5.027-2.27-5.027-5.07v-18.25c0-2.8 2.251-5.07 5.027-5.07 2.776 0 5.027 2.27 5.027 5.07v18.25c0 2.8-2.25 5.07-5.027 5.07Z",
        fill: "#23286B"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M145.31 143.779a1.822 1.822 0 0 0 1.827-1.817v-25.284c0-14.36 11.747-26.044 26.185-26.044h15.27c14.439 0 26.185 11.683 26.185 26.044v25.084c0 1.004.817 1.817 1.826 1.817a1.822 1.822 0 0 0 1.827-1.817v-25.084c0-16.365-13.385-29.678-29.838-29.678h-15.27c-16.453 0-29.838 13.313-29.838 29.678v25.284c0 1.004.818 1.817 1.827 1.817Z",
        fill: "#D6D7D8"
      }
    )
  ] })
] });
const ForwardRef = forwardRef(SvgHelp);
export {
  ForwardRef as default
};
